import { searcherConfigs, TripType, TripTypeShort } from '../models';
import { DataAttributesUtils } from './DataAttributesUtils';
import { DateUtils } from './DateUtils';

const container = document.getElementById('react-app');
const rootDataAttr = DataAttributesUtils.getAllDataAttr(container);

export const getWMPUtils = (dataAttributes) => {
    const hasPrefilledCities = () => {
        const re = new RegExp(/^(from|to)(\d?)$/);
        return Object.keys(dataAttributes).some((dataAttrName) => re.exec(dataAttrName));
    };
    const hasCustomCitiesList = () => {
        const re = new RegExp(/^(from|to)(\d?)(list)$/);
        return Object.keys(dataAttributes).some((dataAttrName) => re.exec(dataAttrName));
    };
    const hasCitiesListForCurrentSegmentAndField = (search, field, segmentIndex) => {
        const dataAttributesList = Object.keys(dataAttributes);
        return search.tripType === TripType.MULTIPLE
            ? dataAttributesList.includes(`${field}${segmentIndex}list`)
            : dataAttributesList.includes(`${field}list`);
    };
    const wasCityPrefilledByDataAttr = (search, field, segmentIndex) => {
        const dataAttributesList = Object.keys(dataAttributes);
        return search.tripType === TripType.MULTIPLE
            ? dataAttributesList.includes(`${field}${segmentIndex}`)
            : dataAttributesList.includes(field);
    };
    const getPrefilledCity = (search, field, segmentIndex) => {
        return search.tripType === TripType.MULTIPLE
            ? dataAttributes[`${field}${segmentIndex}`]
            : dataAttributes[field];
    };
    const getCitiesList = (search, field, segmentIndex) => {
        return search.tripType === TripType.MULTIPLE
            ? dataAttributes[`${field}${segmentIndex}list`].split(',')
            : dataAttributes[`${field}list`].split(',');
    };
    const isInputSameAsDataAttr = (search, field, segmentIndex) => {
        if (wasCityPrefilledByDataAttr(search, field, segmentIndex)) {
            const originOrDestination = field === 'from' ? 'origin' : 'destination';
            const fieldData = search.segments[segmentIndex][originOrDestination];
            const storedIata = fieldData?.iata;
            return storedIata === getPrefilledCity(search, field, segmentIndex);
        }
        return false;
    };
    const shouldWMPCitiesListShow = (input, search, field, segmentIndex) => {
        let shouldShow = false;
        if (!input) {
            shouldShow = !wasCityPrefilledByDataAttr(search, field, segmentIndex);
        } else if (isInputSameAsDataAttr(search, field, segmentIndex)) {
            shouldShow = true;
        }
        return shouldShow;
    };
    const getCampaignExpiration = () => {
        return dataAttributes.campaignexpiration;
    };
    const getCampaignExpirationDate = () => {
        return DateUtils.parse(getCampaignExpiration());
    };
    const isCampaignNotExpired = () => {
        const currCampaignExpirationDate = getCampaignExpirationDate();
        return DateUtils.isNotExpired(currCampaignExpirationDate);
    };
    const getCampaignId = () => {
        return dataAttributes.campaignid;
    };
    const getTripType = () => TripTypeShort[dataAttributes.triptype];
    const getStopoverConfig = () => searcherConfigs[dataAttributes.stopover];
    return {
        hasPrefilledCities,
        hasCustomCitiesList,
        hasCitiesListForCurrentSegmentAndField,
        wasCityPrefilledByDataAttr,
        getPrefilledCity,
        getCitiesList,
        isInputSameAsDataAttr,
        shouldWMPCitiesListShow,
        getCampaignId,
        getCampaignExpiration,
        getCampaignExpirationDate,
        isCampaignNotExpired,
        getTripType,
        getStopoverConfig,
    };
};

export const WMPUtils = getWMPUtils(rootDataAttr);
